import React,{useState} from 'react';
import { Heading, Content } from 'components/api/text'
import CountItem from '../count-item'
import CodeBox from 'components/code-box'
import { Link, useRouteMatch, useHistory } from 'react-router-dom'
import Button from 'components/button'
import Text from 'components/text'
import useGetAccessToken from '../../hooks/useGetAccessToken';
import ConversionTracking from './conversion-tracking';


const JsSetup = ({ mobileView, onDocs }) => {
    const match = useRouteMatch()
    const history = useHistory()
    const { data } = useGetAccessToken()

    return (
        <div className='w-full pb-16'>
            <Button
                tailwind={`w-full  ${!mobileView && 'md:w-auto'}`}
                variant='outline'
                size='extra-small'
                onClick={() => history.goBack()}
            >View all</Button>

            <Heading>Integrate with Javascript</Heading>

            <Text>
                It’s super quick to get RefMonkey running on your website. Follow the walkthrough below to import the RefMonkey JavaScript library and integrate it on your website.
            </Text>

            <CountItem
                number='1'>
                This is your tracking code. Place the code snippet in the head of every page of your website - between the <b>{'<head>'}</b> and <b>{'</head>'}</b> HTML tags.
            </CountItem>
            <CodeBox>{`<script src="https://cdn.refmonkey.com/refmonkey.js"></script>
<script type="text/javascript">window.refMonkeyClient = RefMonkey.client(${data ? '"' + data.generateAccessToken + '"' : 'YOUR_ACCESS_TOKEN'}); </script>`}
            </CodeBox>
         
            <ConversionTracking onDocs={onDocs}/>

            <div className='mt-16'>
                <Content ><b>Important:</b> This concludes our setup instructions for our most basic form of integration.</Content>
            </div>

            <Content>For all additional tracking posibilities, like referral links and more…
                 please check our<Link
                    onClick={onDocs}
                    className='text-blue-500 hover:text-blue-400'
                    to={`${match.url}/docs`}> complete refmonkey.js reference.</Link></Content>

           

        </div>
    );
};

JsSetup.propTypes = {

};

export default JsSetup;